import { render, staticRenderFns } from "./MobileRouterButtons.vue?vue&type=template&id=82b0b36e&scoped=true&"
import script from "./MobileRouterButtons.vue?vue&type=script&lang=js&"
export * from "./MobileRouterButtons.vue?vue&type=script&lang=js&"
import style0 from "./MobileRouterButtons.vue?vue&type=style&index=0&id=82b0b36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b0b36e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
